export const signUpEvent = () => {
  console.log('track - registration');
  if (window?.fbq) {
    window.fbq('track', 'CompleteRegistration');
  }
};

export const depositEvent = () => {
  console.log('track - purchase');
  if (window?.fbq) {
    window.fbq('track', 'Purchase');
  }
};

export const pageViewEvent = () => {
  console.log('track - pageview');
  if (window?.fbq) {
    window.fbq('track', 'PageView');
  }
};

export const depositInitiated = () => {
  console.log('track - deposit initiation');
  if (window?.fbq) {
    window.fbq('track', 'AddToCart');
  }
};
